<template lang="pug">
    div
        router-view

        //- Open if not registered user
        LoginDialogWindow

        //- Open if visitor user
        EdgerSplashScreen
</template>

<script>
import LoginDialogWindow from './components/LoginDialogWindow.vue';
import EdgerSplashScreen from './components/EdgerSplashScreen.vue';

export default {
    name: 'App',
    components: {
        LoginDialogWindow,
        EdgerSplashScreen
    }
}
</script>
